// extracted by mini-css-extract-plugin
export var button = "styles-module--button--vlloT";
export var buttonFlared = "styles-module--button-flared--yXRPo";
export var buttonMain = "styles-module--button-main--fDvO4";
export var buttonLink = "styles-module--button-link--g4ANr";
export var buttonArrow = "styles-module--button-arrow--JRRAf";
export var buttonTransparent = "styles-module--button-transparent--VRBxv";
export var buttonGray = "styles-module--button-gray--k2miU";